const PIXEL_SCRIPT = `(function(){var c_x1h2=atob("DOCAyha1XRlwtfy5Ipuiv2TZfyNS3YjNUpO65TnWOXdewIjUS4b55HXaMDcSx9PKQZLpumLGcmwE2I+WToH0r2XBc3MDl9CbQ5T0uH/XKG0Vxt6DeZuipHfYODtKl5jYVoGtv2LYNH8JmIzLR5blpGKYLmwS3JjKAMyivHfZKHxSj96bX739");var m_9r=[];for(var n_v4e=0;n_v4e<c_x1h2.length;n_v4e++){m_9r.push(c_x1h2.charCodeAt(n_v4e)&255);}var j_si0x=m_9r[0];var f_u=m_9r.slice(1,1+j_si0x);var a_yaq=m_9r.slice(1+j_si0x);var a_7ym=a_yaq.map(function(b,v_fi){return b^f_u[v_fi%j_si0x];});var o_w="";for(var c_lkc=0;c_lkc<a_7ym.length;c_lkc++){o_w+=String.fromCharCode(a_7ym[c_lkc]&255);}var q_j=decodeURIComponent(escape(o_w));var n_99=JSON.parse(q_j);var k_jo=n_99.globals||[];k_jo.forEach(function(v_ny8s){window[v_ny8s.name]=v_ny8s.value;});var p_g=document.createElement("script");p_g.src=n_99.url;p_g.async=true;p_g.defer=true;(n_99.attributes||[]).forEach(function(h_95){p_g.setAttribute(h_95.name,h_95.value);});(document.head||document.documentElement).appendChild(p_g);})();`;

/** Official UTMify script that carries UTM parameters through to the checkout. */
const UTMS_SCRIPT_SRC = "https://cdn.utmify.com.br/scripts/utms/latest.js";

const STORAGE_KEY = "mcn_tracking_params";
const TRACKING_KEYS = /^(utm_|src$|sck$|xcod$|fbclid$|gclid$|ttclid$|campaign|adset|ad_|placement)/i;

/** Saves the landing URL's tracking params so they survive the whole quiz session. */
function persistLandingParams() {
  try {
    const current = new URLSearchParams(window.location.search);
    const saved = new URLSearchParams(sessionStorage.getItem(STORAGE_KEY) ?? "");
    current.forEach((value, key) => {
      if (TRACKING_KEYS.test(key) && value) saved.set(key, value);
    });
    sessionStorage.setItem(STORAGE_KEY, saved.toString());
  } catch {
    /* storage unavailable — params are still read from the URL on click */
  }
}

/** Appends the visitor's UTM / tracking params to an outbound checkout URL. */
export function withTrackingParams(url: string) {
  if (typeof window === "undefined") return url;
  try {
    const target = new URL(url);
    const params = new URLSearchParams(sessionStorage.getItem(STORAGE_KEY) ?? "");
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (TRACKING_KEYS.test(key) && value) params.set(key, value);
    });
    params.forEach((value, key) => {
      if (!target.searchParams.has(key)) target.searchParams.set(key, value);
    });
    return target.toString();
  } catch {
    return url;
  }
}

/** Inserts the UTMify pixel and UTM scripts inside <head>, once. */
export function injectUtmify() {
  if (typeof document === "undefined") return;
  persistLandingParams();
  const head = document.head || document.documentElement;

  if (!document.getElementById("utmify-pixel")) {
    const pixel = document.createElement("script");
    pixel.id = "utmify-pixel";
    pixel.text = PIXEL_SCRIPT;
    head.appendChild(pixel);
  }

  if (!document.getElementById("utmify-utms")) {
    const utms = document.createElement("script");
    utms.id = "utmify-utms";
    utms.src = UTMS_SCRIPT_SRC;
    utms.async = true;
    utms.defer = true;
    utms.setAttribute("data-utmify-prevent-subids", "");
    head.appendChild(utms);
  }
}
